<template>
  <widget
    :color="color"
    icon="fa fa-robot"
    title="Success calls"
    :percent="percent"
    :value="value"
    :loading="loading"
  />
</template>

<script>
import apiDashboard from '@/apis/dashboard'

import Widget from '@/components/widget/widget9'

export default {
  props: {
    clear: Number,
    refresh: Object,
    from: String,
    to: String,
    direction: String
  },
  components: {
    Widget
  },
  data() {
    return {
      color:
        this.direction === 'outbound'
          ? this.$getVoiceOutboundColor[0]
          : this.$getVoiceColor[0],
      percent: 0,
      value: 0,
      loading: false
    }
  },
  watch: {
    clear: {
      handler(val) {
        if (val) this.loading = true
      }
    },
    'refresh.count': {
      immediate: true,
      handler(val) {
        this.getVoiceSessionSuccessByBot()
      }
    }
  },
  methods: {
    async getVoiceSessionSuccessByBot() {
      this.loading = true

      try {
        const obj = {
          from: this.from,
          to: this.to,
          direction: this.direction
        }

        const success = await apiDashboard.getVoiceSessionSuccess(obj)
        this.value = success.total
        this.percent = success.percent
      } catch {
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
